import React from "react";

const DentalOrOpticalCheckListContent = {
  checklistText: (
    <React.Fragment>
      <p>
        Dental or Optical cash benefit is not available on all plans. Please
        check your handbook to see if you have cover.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: ["Fully itemised invoices, receipts, or bills for your claim",
  "This should include the patient’s name with the dates, amounts and details of the items or treatment"],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const DentalOrOptical = {
  HOL: {
    ...DentalOrOpticalCheckListContent,
    checklistText: (
      <React.Fragment>
        <p>
          Dental or Optical cash benefit is not available on all policies.
          Please check your handbook to see if you have cover.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Saga: {
    ...DentalOrOpticalCheckListContent,
    checklistText: (
      <React.Fragment>
        <p>
          Dental, Optical and Health screening cash benefit is not available on
          all plans. Please check your handbook to see if you have cover.
        </p>
        <p>
          <strong>Dental treatment</strong> (including check-up or new dentures)
          up to the maximum benefit levels and if you've paid directly to a
          dentist or dental hygienist who's registered with the General Dental
          Council.
        </p>
        <p>
          <strong>Optical treatment</strong> up to the maximum benefit levels
          and if you have paid an optician for eyesight tests or prescribed
          spectacles, lenses or contact lenses. This doesn't cover contact lens
          check-ups or solutions, non-prescribed spectacle repairs, new frames,
          replacements needed after accidental damages, or non-prescribed items
          you buy under an optical care contract scheme. If you do buy items
          under an optical care contract and you want to claim from your plan,
          you must ask your optician to provide a receipt showing the cost of
          all items you have bought under that contract.
        </p>
        <p>
          <strong>Health screening</strong> up to the maximum benefit levels and
          if you've paid directly to a medical facility to carry out a health
          screening examination. Any additional investigations or treatment
          required following the health screening will be subject to the terms
          and benefit limits of your plan.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: DentalOrOpticalCheckListContent
};

export default DentalOrOptical;
